import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultVerificationMetricResource,
    useVerificationMetricActions,
    VerificationMetricMutationResourceSchema,
    type VerificationMetricResource,
} from '../../../../../resource/resources/artifacts/verification_metric/verificationMetricResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { VerificationMetricContent } from './VerificationMetricContent';

export const VerificationMetricCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: VerificationMetricResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const verificationMetricActions = useVerificationMetricActions();
    const addVerificationMetric = verificationMetricActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: VerificationMetricMutationResourceSchema,
        defaultValues: {
            ...defaultVerificationMetricResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addVerificationMetric.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Verification Metric'}
            resourceType={ResourceType.VERIFICATION_METRIC}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <VerificationMetricContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
